import React, { Component } from 'react'
import { Form, Divider, InputNumber, Button, Spin } from 'antd'
import { inject, observer } from 'mobx-react'

@inject("stockStore")
@observer
class UpdateStock extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
    }

    stockChange = (value) => this.props.stockStore.setStock(value)

    cancelUpdateStockButtonClicked = () => {
        this.props.stockStore.setShowUpdateStockModal(false)
    }

    updateStockButtonClicked = () => {
        this.props.stockStore.updateStock()
    }

    render() {
        const {
            taskName,
            category,
            minimumStock,
            currentStock,
            updateLoading
        } = this.props.stockStore;

        return (
            <Spin spinning={updateLoading}>
                <Form layout="vertical">
                    <Form.Item label="Category">
                        <b>{category}</b>
                    </Form.Item>
                    <Form.Item label="Task Name">
                        <b>{taskName}</b>
                    </Form.Item>
                    <Form.Item label="Minimum Stock">
                        <b>{minimumStock}</b>
                    </Form.Item>

                    <Divider>Adjust Your Stock</Divider>
                    <Form.Item label="Adjust Stock">
                        <InputNumber min={minimumStock} value={currentStock} onChange={this.stockChange} />
                    </Form.Item>

                    <Form.Item>
                        <Button onClick={this.updateStockButtonClicked} type="primary" style={{ marginRight: 10 }}>Update</Button>
                        <Button onClick={this.cancelUpdateStockButtonClicked}>Cancel</Button>
                    </Form.Item>
                </Form>
            </Spin>
        )
    }
}

export default UpdateStock